import api from '../../../services/api';

// P7a — E14 Çalışan performans profili. Uçlar (BE ile birebir):
//   GET  v1/performance-profile/{employeeId}?periodId=   → PmProfileDto (İK kiracı; yönetici kişi kümesi; kendisi 403 → E18)
//   POST v1/performance-profile/{employeeId}/summary {periodId}   → LLM yönetici özeti (AI Plus; sayı doğrulaması geçmezse 502)
// api.js GET'te reject ETMEZ: hata sinyali res.data.status — "yetki yok" (403 anahtarı) ile "yüklenemedi" ayrı durumdur.

export const FORBIDDEN_KEYS = ['performance.profile.forbidden', 'performance.profile.self', 'performance.analytics.forbidden'];

export async function fetchProfile(employeeId, periodId) {
  const res = await api.get(`/v1/performance-profile/${employeeId}`, { params: periodId ? { periodId } : {} });
  if (res?.data?.status) return { data: res.data.data };
  const message = res?.data?.message || 'error';
  return { error: FORBIDDEN_KEYS.includes(message) ? 'forbidden' : 'failed', message };
}

// Hata tostu yakalayıcıda; burada yalnız null döner (düğme yeniden denenebilir kalır).
export async function summarizeProfile(employeeId, periodId) {
  try {
    const res = await api.post(`/v1/performance-profile/${employeeId}/summary`, { periodId }, { timeout: 90000 });
    return res?.data?.data || null;
  } catch {
    return null;
  }
}

export const SUMMARY_FIELDS = ['summary', 'strengths', 'focusAreas', 'discussionPoints'];

export function profileTabs(viewer) {
  return [
    'summary', 'goals', 'competencies', 'reviews', 'meetings',
    ...(viewer?.tdVisible ? ['development', 'talent'] : []),
    'history',
  ];
}

/** Breadcrumb kaynağı: yalnız uygulama içi performans yolları (açık yönlendirme yok). */
export function safeFrom(from) {
  if (!from || typeof from !== 'string') return null;
  return from.startsWith('/performance/') && !from.startsWith('//') ? from : null;
}

export const isFinalState = (s) => s === 'calibrated' || s === 'published';

// Son 3 karşılaştırılabilir dönem grafiği: normalize final (0–100) ve hedef puanı (0–100) aynı eksende.
export function historySeries(history) {
  return (history || []).map((h) => ({
    name: h.name,
    final: h.finalNormalized != null ? Number(h.finalNormalized) : null,
    goal: h.goalScore != null ? Number(h.goalScore) : null,
  }));
}
